module.exports = __webpack_public_path__ + "img/rightnxt.01e3e36f.svg";